import { getConfigProperty } from '@/common/oldMobile';
import Immutable from 'immutable';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import './handlers';
import './subs';
import { getKeepBetsSettings } from '@/services/localStorageData';
import reframe from 'nike-re-framejs';
import BetslipLoadable from './views/BetslipLoadable';
import subscribeSubmitStreams from './submit';
import startBetslipPush from './push';
import { isProfileNoBetslip } from 'nike-ui/src/profiles';

export const configureBetslip = function(db) {
    // vacsinu nastaveni (Rx subscripcie a Push subscripcie) nechcem robit pocas "boot-time"
    // ale az po pridani prveho picku to tiketu (lebo verim ze to zrychli startup time)

    !isProfileNoBetslip() && deferBetslipSetup();

    return db
        .set(
            'config',
            Immutable.fromJS({
                actualCurrency: getConfigProperty('actualCurrency')
            })
        )
        .setIn(['betslip', 'keepBets'], getKeepBetsSettings());
};

function deferBetslipSetup() {
    const sub = reframe.db$
        .pipe(
            map(db => db.getIn(['server', 'betslip', 'betCount']) > 0),
            filter(Boolean),
            distinctUntilChanged()
        )
        .subscribe(function() {
            // preloadni cely betslip
            BetslipLoadable.preload();

            // "zapni" betslip "submit streamy"
            subscribeSubmitStreams();

            // nastartuj betslip push
            startBetslipPush();

            //onetime job
            sub.unsubscribe();
        });
}
